import badge132Avif from "../assets/logo/badge-132.avif";
import badge132Webp from "../assets/logo/badge-132.webp";

interface LeagueBadgeProps {
  className: string;
  /** Rendered width and height in CSS pixels, reserving the image's box before it loads. */
  size: number;
}

/**
 * The league badge at header size, always decorative (`alt=""`) because the
 * league name sits beside it or in its button's label. The 132px source
 * covers up to 44px at 3x density. Built from assets-src/logo.jpg by
 * `make logo` (build-logo.mjs); AVIF first, WebP for browsers without it.
 */
export function LeagueBadge({ className, size }: LeagueBadgeProps) {
  return (
    <picture className="logo-picture">
      <source type="image/avif" srcSet={badge132Avif} />
      <img className={className} src={badge132Webp} alt="" width={size} height={size} />
    </picture>
  );
}
